import { DatabaseGwService } from '../database-gw.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MetadataConfigService extends DatabaseGwService {
  URL_PATH: string = "/metadatas"
}
